export const FETCH_USER_TIMETABLE = "FETCH_USER_TIMETABLE";
export const FETCH_DEPARTMENT_TIMETABLE = "FETCH_DEPARTMENT_TIMETABLE";
export const FETCH_FACULTY_TIMETABLE = "FETCH_FACULTY_TIMETABLE";
export const FETCH_FACULTY_DEAN = "FETCH_FACULTY_DEAN";